import './App.css';
import useRefreshToken from './hooks/useRefreshToken';
import { Route, Routes } from 'react-router-dom';
import Core from './components/layout/Core';
import { createTheme, ThemeProvider } from '@mui/material';
import { roleOptions } from './utils/appRoles';
import PrivateRoutes from './routes/PrivateRoutes';
import Page from './components/layout/Page';

// pages
import NotFoundPage from './pages/NotFoundPage';
import CreateUserPage from './pages/CreateUserPage';
import LoginRoute from './routes/LoginRoute';
import useAxiosAuth from './hooks/useAxiosAuth';
import UserListPage from './pages/UserListPage';
import UpdateUserPage from './pages/UpdateUserPage';
import ArticlesPage from './pages/ArticlesPage';
import CreateAritclePage from './pages/CreateAritclePage';
import LogoutPage from './pages/LogoutPage';
import DashboardPage from './pages/DashboardPage';
import UpdateAritclePage from './pages/UpdateAritclePage';
import ArticleCategoryPage from './pages/ArticleCategoryPage';
import UpdateUserPasswordPage from './pages/UpdateUserPasswordPage';
import RequestNewPasswordPage from './pages/RequestNewPasswordPage';
import ArticleDetailPage from './pages/AriticleDetailPage';
import { HOME_URL } from './contexts/PageProvider';
import { ARTICLE_LIST_URL } from './contexts/PageProvider';
import { USER_LIST_URL } from './contexts/PageProvider';
import NotificationsSystem, { bootstrapTheme, setUpNotifications, useNotifications, FadeTransition } from "reapop";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


function App() {
  const {ADMIN, HR} = roleOptions;
  const {notifications, dismissNotification} = useNotifications()
  const auth = useRefreshToken();

  useAxiosAuth();

  const contrastText = "#909aa3";
  const theme = createTheme({
    palette: {
      mode: "light",
      primary: {
        light: "#1089FF",
        main: "#1057C8",
        dark: "#001A70",
        ...contrastText
      },
      secondary: {
        light: "#FFB210",
        main: "#FF861D",
        dark: "#FE5716",
        ...contrastText
      },
      success: {
        light: "#C04E10",
        main: "#88D910",
        dark: "#4F9E30",
        ...contrastText
      },
      background: {
        light: "#FFFFFF",
        main: "#FFFFFF",
        dark: "#001A70",
        ...contrastText
      }
    },
  });

  setUpNotifications({
    defaultProps: {
        position: 'top-right',
        dismissible: true
    } 
  })

  const notificationIcon = () => {
    return <div style={{margin: '14px'}}><InfoOutlinedIcon color="primary"/></div>
  };

  return (
    <>
      {auth &&           
        <ThemeProvider theme={theme}>
          <Routes>
            <Route element={<PrivateRoutes/>}>
              <Route path={HOME_URL} element={<Core/>} >
                <Route index element={<Page page={<DashboardPage/>}/>} />
                <Route path={USER_LIST_URL} element={<PrivateRoutes accessList={[ADMIN, HR]}/>}>
                  <Route index element={<Page page={<UserListPage/>} />} />
                  <Route path="create" element={<Page page={<CreateUserPage/>} />} />
                  <Route path="update/:id" element={<Page page={<UpdateUserPage/>} />} />
                  <Route path="view/:id" element={<Page page="users view"/>} />
                  <Route path="destroy/:id" element={<Page page="users destroy"/>} />
                </Route>
                <Route path={ARTICLE_LIST_URL} element={<PrivateRoutes accessList={[ADMIN, HR]}/>} >
                  <Route index element={<Page page={<ArticlesPage/>} />} />
                  <Route path="create" element={<Page page={<CreateAritclePage/>} />} />
                  <Route path="category" element={<Page page={<ArticleCategoryPage/>} />} />
                  <Route path="update/:id" element={<Page page={<UpdateAritclePage/>} />} />
                </Route>
                <Route path="/article/view/:id" element={<Page page={<ArticleDetailPage/>} />} />
                <Route path='/me' element={<Page page="me"/>} />
                <Route path='/about' element={<Page page="about"/>} />
                <Route path='/logout' element={<LogoutPage/>} />
                <Route path='*' element={<NotFoundPage/>} />
              </Route>
            </Route>

            <Route path='/login' element={<LoginRoute/>} />
            <Route path='/user/request_new_password' element={<RequestNewPasswordPage/>} />
            <Route path='/user/new_password/:uidb64/:id' element={<UpdateUserPasswordPage/>} />

          </Routes>
          <NotificationsSystem
              notifications={notifications}
              dismissNotification={(id) => dismissNotification(id)}
              components={{Transition: FadeTransition, NotificationIcon: notificationIcon}}
              theme={bootstrapTheme}
          />
        </ThemeProvider>
      }
    </>
  );
}

export default App;
